module.exports = __webpack_public_path__ + "static/media/TP_Icon_BottleOpener2.51b51973.png";